import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentDialogService} from "../../../agents/services/agent-dialogs-service.service";
import {AgentsAlerts} from "../../../agents/services/agents-alerts.service";
import {$agentFactory} from "../../../agents/$agent.factory";
import {$agentsFactory} from "../../../agents/$agents.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {BranchModel} from "../../models/branch.model";
import {AgentsService} from "../../../agents/services/agents-service.service";

export class BranchesAgentsViewCtrl implements IController {

  branch: BranchModel;

  private loading = false;
  private queryString = undefined;
  private avoidIds = [];
  private agentType = 'ALL';
  private selectedAgentTypes = undefined;
  public doReload: boolean = false;

  private agentTypes: any;
  private agentsRef: any;
  private agentIdToRemove: any;

  /* @ngInject */
  constructor(private agentDialogService: AgentDialogService, private bringozLoaderService: BringozLoaderService,
              private IAMPermissions, private $agent: $agentFactory, private agentsAlerts: AgentsAlerts,
              private $log, private confirmDialogService: ConfirmDialogService, private $agents: $agentsFactory,
              private agentConstants, private agentsService: AgentsService) {}

  $onInit() {
    this.agentsRef = this.$agents();
    let agentTypes = angular.copy(this.agentConstants.types);
    agentTypes.unshift(this.agentType);
    this.agentTypes = agentTypes;

    this.agentsRef.$getAll({branchIds: [this.branch.id],  active: true})
      .then((agentIds) => {
        this.avoidIds = agentIds;
      })
  }

  submitQuery(query) {
    this.queryString = query;
  }

  onInviteAgent(event) {
    return this.agentDialogService.addAgents(event, this.avoidIds)
      .then((payload) => {
        return this.agentsService.addBranches([this.branch.id], payload.ids)
      })
      .then((updatedAgents) => {
        updatedAgents.forEach((a) => {
          this.avoidIds.push(a.id);
        })

        // For Refreshing List
        this.doReload = true
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to invite agent to branch @branchesDriversView@onInviteAgent', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
  }

  onCreateAgent(event) {
  this.agentDialogService.createAgent(event, undefined, this.branch.id)
      .then((createdAgent) => {
        this.avoidIds.push(createdAgent.id);
      })
  }

  onRemoveAgent(agent, event) {
  this.confirmDialogService.confirm('Remove Driver', 'Are you sure you want to remove this driver from branch?', event)
      .then(() => {
        let agentCopy = angular.copy(agent);
        agentCopy.branchIds = _.without(agent.branchIds, this.branch.id);

        this.loading = true;
        return this.$agent(agent.id).$update(agentCopy);
      })
      .then((agentRemoved) => {
        this.avoidIds = _.filter(this.avoidIds, (idToAvoid) => {
          return idToAvoid !== agentRemoved.id;
        });
        this.agentIdToRemove = agentRemoved.id;
        this.agentsAlerts.removeFromBranchSuccess(agentRemoved);
      })
      .catch((error) => {
        if (error) {
          this.agentsAlerts.removeFromBranchError();
          this.$log.info('Failed to remove agent from branch ' +
            '@branchesAgentsView@onRemoveAgent', event);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onAgentTypeSelect(agentType) {
    this.selectedAgentTypes = _.isEqual(agentType, 'ALL') ? undefined : [agentType];
  }

  onReload() {
    this.doReload = false;
  }

}
angular
  .module('bringoz.admin.branches')
  .component('branchesAgentsView', {
    bindings: {
      branch: '<'
    },
    template: require('./branches-agents-view.html').default,
    controller: BranchesAgentsViewCtrl
  });
